const sundarbansDetails = [
    {
    id: 6,
    category: "sundarban",
    name: "Hotel Tropical Dalsy",
    capacity: "4 guests 2 bedrooms 2 beds  2 baths",
    shortDescription: "Wif Air Condition Kitchen",
    facility: "Cancellation flexibility available",
    stars: "4.9(20)",
    price: 39,
    totalPrice: "167 total",
    details: "The Sundarbans is a mangrove area in the delta formed by the confluence of the Ganges, Brahmaputra and Meghna Rivers in the Bay of Bengal. It spans from the Hooghly River in India's state of West Bengal to the Baleswar River in Bangladesh",
    photo: "https://images.pexels.com/photos/262048/pexels-photo-262048.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    origin: "Dhaka",
    Destination: "Bagerhat"
},
    {
    id: 7,
    category: "sundarban",
    name: "Pan Pacific Sonargao",
    capacity: "4 guests 2 bedrooms 2 beds 2 baths",
    shortDescription: "Wilf Air Condition Kitchen",
    facility: "Cancellation flexibility available",
    stars: "4.9(25)",
    price: 54,
    totalPrice: "167 total",
    details: "The Sundarbans is a mangrove area in the delta formed by the confluence of the Ganges, Brahmaputra and Meghna Rivers in the Bay of Bengal. It spans from the Hooghly River in India's state of West Bengal to the Baleswar River in Bangladesh",
    photo: "https://images.pexels.com/photos/2416933/pexels-photo-2416933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    origin: "Dhaka",
    Destination: "Bagerhat"
},
    {
    id: 8,
    category: "sundarban",
    name: "Royal Resort",
    capacity: "4 guests 2 bedrooms 2 beds 2 baths",
    shortDescription: "Wilf Air Condition Kitchen",
    facility: "Cancellation flexibility available",
    stars: "4.9(45)",
    price: 34,
    totalPrice: "167 total",
    details: "The Sundarbans is a mangrove area in the delta formed by the confluence of the Ganges, Brahmaputra and Meghna Rivers in the Bay of Bengal. It spans from the Hooghly River in India's state of West Bengal to the Baleswar River in Bangladesh",
    photo: "https://images.pexels.com/photos/1329711/pexels-photo-1329711.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    origin: "Dhaka",
    Destination: "Bagerhat"
},
]
export default sundarbansDetails;